import { NgModule } from '@angular/core';
import { LibIncomeIconComponent } from './lib-income-icon.component';

@NgModule({
  declarations: [LibIncomeIconComponent],
  imports: [],
  exports: [LibIncomeIconComponent],
})
export class LibIncomeIconModule {}
